export { default as typography, variants } from './typography.js';
